import { forwardRef } from "react";
import type { IconsaxProps } from "./Iconsax.types.js";

export const CloseLinear = forwardRef<HTMLDivElement, IconsaxProps>(({ size = 24, color = "currentColor", ...rest }, ref) => {
    return (
        <div ref={ref} {...rest} style={{ display: "flex", width: "fit-content", alignItems: "center", justifyContent: "center", ...rest.style }}>
            <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M3.66889 3.66987C3.96178 3.37697 4.43666 3.37697 4.72955 3.66987L11.9993 10.9396L19.2689 3.66993C19.5618 3.37704 20.0367 3.37704 20.3295 3.66993C20.6224 3.96282 20.6224 4.4377 20.3295 4.73059L13.0599 12.0002L20.3295 19.2698C20.6224 19.5627 20.6224 20.0376 20.3295 20.3305C20.0366 20.6234 19.5617 20.6234 19.2688 20.3305L11.9993 13.0609L4.72962 20.3305C4.43672 20.6234 3.96185 20.6234 3.66895 20.3305C3.37606 20.0376 3.37606 19.5628 3.66895 19.2699L10.9386 12.0002L3.66889 4.73053C3.376 4.43763 3.376 3.96276 3.66889 3.66987Z"
                    fill={color}
                />
            </svg>
        </div>
    );
});
